require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/fn/regexp/escape.js
// module id = 325
// module chunks = 0